import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRounded: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowRounded"><Path fillRule="evenodd" clipRule="evenodd" d="M16.75 3.18945L21.3107 7.75011L16.75 12.3108L15.6893 11.2501L18.4393 8.50011H12.75C10.4028 8.50011 8.5 10.4029 8.5 12.7501V14.5001H7V12.7501C7 9.57448 9.57436 7.00011 12.75 7.00011H18.4393L15.6893 4.25011L16.75 3.18945ZM3.5 7.00011V18.5001H20V20.0001H2V7.00011H3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRounded;
